import styled from 'styled-components'

export const StyledReports = styled.div`
`

export const StyledReport = styled.div`
    background-color: ${({ theme }) => theme.whiteTwo};
    margin-bottom: 5px;
    padding: 10px;
    box-shadow: 0 6px 18px 0 ${({ theme }) => theme.blueyGrey22};
    border-radius: 4px;
    overflow-x: auto;
`